import { FC } from 'react'
import { SubText, TitleH2Styledv2 } from 'components/Common/Typography'
import { Col, Container, Row } from 'react-bootstrap'
import { Uprightarrow } from 'components/Common/Icon'
import Link from 'next/link'
import { CDN_URL } from 'services/config'
import Image from 'next/image'


const FeatureBlock: FC<{ data }> = ({ data }) => {
  return (
    <section className="feature_block new_feature_block pt-120px pb-120px">
      <Container>
        <div className="feature_inner our_work">
          <Row className='align-items-center'>
            <Col xl={9} className="d-flex flex-column">
              <TitleH2Styledv2 className="mb-0 secondry-color" text={data?.title} blueTitle={''} blueTitle2={''} />
              <SubText className="" text={data.smallText} />
            </Col>
            <Col
              xl={3}
              className="d-flex flex-column align-items-center justify-content-center align-items-xl-end mt-xl-0 mt-3"
            >
              <div className="va_link_wrap mouse text-center">
                <Link href="/portfolio" className="text-decoration-none">
                  <div className="va_icon">
                    <svg
                      width="230"
                      height="230"
                      viewBox="0 0 230 230"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="115" cy="115" r="115" fill="currentColor" />
                      <path
                        d="M139.639 87.6656L78.3193 148.348L82.9956 153.236L143.039 93.1933L143.039 126.775L150.478 126.775L150.584 80.3339L150.372 80.3339L143.146 80.3323L103.931 80.2264L103.931 87.6656L139.639 87.6656Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  )
}

export default FeatureBlock
